import { getLoginTokenRequest } from '@/services/API/auth/AuthRequestService'
import store from '@/store/store'

/**
 * @description
 * Call request for get Login token and save it in Local Storage
 * 
 * @param {oject} params
 * @return {Promise}
 */
const getAndSaveLoginToken = (tokenByUser = undefined) => {
    return new Promise((resolve, reject) => {
        let loginToken = tokenByUser !== undefined ? tokenByUser: getLoginToken_FromParams()
        if (loginToken !== undefined) {
            let params = { login_token: loginToken }
            getLoginTokenRequest(params)
                .then(response => {
                    store.dispatch('AuthModule/loginActions', response ) // create local storage user data
                    resolve(response)
                })
                .catch((err) => {
                    store.dispatch('AuthModule/logoutActions') // delete local storage user data
                    reject(err)
                })
        } else
            reject( getErrorObject_IfTokenNotExistInURL() )
    })
} // end function

/**
 * @description
 * Logout User (Delete data from Local Storage)
 * 
 * @return {void}
 */
const logoutUser = () => {
    store.dispatch('AuthModule/logoutActions') // delete local storage user data
} // end function

/**
 * @description
 * Get Object error when token not exist in URL
 * @return {Object}
 */
function getErrorObject_IfTokenNotExistInURL()
{
    return {
        error: {
            response: {
                status: 500,
                message: 'token no existe en URL'
            }
        }
    }
}

/**
 * @description
 * Get module token from params
 * @return {void}
 */
const getLoginToken_FromParams = () => {
    try {
        return window.location.search.substr(1).split('=')[1];
    } catch (err) {
        return undefined
    }
    
} // end function


export {
    getAndSaveLoginToken,
    logoutUser,
}